import React from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import Filters from "../Filters";
import Icon from "../../../../../../../../../elements/icon/Icon";
import { TableWrapper, TableContainer, PaginationWrapper, LoadingContainer, NoDataWrapper, NoDataTitle, NoDataDescription } from "./AuditLogTableSection.styled";

const AuditLogTableSection = ({
  tableData,
  headers,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  onSortChange,
  onOrderChange,
  selectedSortOption,
  orderDirection,
  onSearchChange,
  onRoleChange,
  onActionChange,
  onSectionChange,
}) => {
  const showEmptyState = !loading && tableData.length === 0;

  return (
    <TableWrapper>
      <TableContainer>
        <Filters
          onSortChange={onSortChange}
          onOrderChange={onOrderChange}
          selectedSortOption={selectedSortOption}
          orderDirection={orderDirection}
          onSearchChange={onSearchChange}
          onRoleChange={onRoleChange}
          onActionChange={onActionChange}
          onSectionChange={onSectionChange}
          loading={loading}
        />
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : showEmptyState ? (
          <NoDataWrapper>
            <Icon name="noDataAvailable" width="201px" height="195px" />
            <NoDataTitle>No audit log yet</NoDataTitle>
            <NoDataDescription>
              No audit logs found for this department.
            </NoDataDescription>
          </NoDataWrapper>
        ) : (
          <Table
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
          />
        )}
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default AuditLogTableSection;

